<template>
    <!--START PROCESS-->
        <section class="section bg-light">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfrLNPea_YfshH8uV2VqnpyMSt7ToW3ijqx0S3yZSsjVkj82A/viewform?embedded=true" width="640" height="1240" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>

                    </div>
                </div>
            </div>
        </section>
        <!--END PROCESS-->
</template>

<script>
"use strict";
export default {
  name: 'Endorse',
  props: {
  }
}
</script>
